var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.574,
    height: 23.493,
    viewBox: "0 0 26.574 23.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-reply",
    "data-name": "Icon awesome-reply",
    d: "M.407,9.98,9.026,2.537a1.176,1.176,0,0,1,1.944.89v3.92c7.866.09,14.1,1.667,14.1,9.122a10.011,10.011,0,0,1-4.081,7.548.873.873,0,0,1-1.375-.912c2.221-7.1-1.053-8.987-8.648-9.1v4.305a1.176,1.176,0,0,1-1.944.89L.407,11.759a1.176,1.176,0,0,1,0-1.779Z",
    transform: "translate(0.75 -1.477)",
    fill: "none",
    stroke: "#40eefe",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsReply);
export default __webpack_public_path__ + "static/media/forum-details-reply.2b84cd97c7ad53abeff80c0764baf389.svg";
export { ForwardRef as ReactComponent };